import React from "react";
import {NavLink} from "react-router-dom";
import {Camion, ChevronRight} from "assets/icons";
import UseContext from "hooks/useContext";
import {formatLicenceLabel, pickLicenceExpiryAlert} from "helper/licences";
import {formatCalendarDate} from "helper/residencePermit";

const LICENCES_PAGE = "/profil/justificatifs/licence";

// Reads the worker loaded in the context (set by usefetchdata, which the other dashboard blocks
// already call) instead of fetching it a second time.
const LicenceExpiryBanner = () => {
    const {tempData, language} = UseContext();
    const licence = pickLicenceExpiryAlert(tempData?.licences);
    if (!licence) return null;

    const translate = (key) => language.getValue(`licences.expiry_banner.${key}`);
    const label = formatLicenceLabel(licence, language.getValue("licences.label_with_category") || undefined);
    const titleKey = licence.state === "expired" ? "expired_title" : "expiring_title";
    const title = translate(titleKey)
        .replace("{label}", label)
        .replace("{date}", formatCalendarDate(licence.expiration));

    return (
        <NavLink
            to={LICENCES_PAGE}
            className="flex items-center gap-4 mx-4 mb-8 px-5 py-4 rounded-xl bg-yellow-500 text-white hover:bg-yellow-600"
        >
            <div className="shrink-0 w-12 h-12 flex items-center justify-center rounded-lg" style={{backgroundColor: "rgba(255, 255, 255, 0.2)"}}>
                <Camion w={22} h={18} color={"#FFFFFF"}/>
            </div>
            <div className="flex flex-col grow">
                <span className="ft-b font-semibold">{title}</span>
                <span className="ft-sm opacity-90">{translate("text")}</span>
            </div>
            <ChevronRight wh={20} color={"#FFFFFF"}/>
        </NavLink>
    );
};

export default LicenceExpiryBanner;
